/**
 * @generated SignedSource<<dc84e93c6764cbac21c6759d65944ff8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type KudosSummaryQuery$variables = {
  internalId?: string | null;
  username?: string | null;
};
export type KudosSummaryQuery$data = {
  readonly unified: {
    readonly unifiedProfile: {
      readonly extensions?: ReadonlyArray<{
        readonly errorType: string | null;
        readonly statusCode: number | null;
      }> | null;
      readonly gamification?: {
        readonly levels?: {
          readonly currentLevelArt?: string | null;
          readonly currentLevelDescription?: string | null;
          readonly currentLevelName?: string | null;
          readonly currentPoints?: number | null;
          readonly id?: string;
          readonly maxPoints?: number | null;
          readonly nextLevelName?: string | null;
        } | null;
        readonly recognitionsSummary?: {
          readonly id?: string;
          readonly totals?: ReadonlyArray<{
            readonly comment: string | null;
            readonly count: number | null;
          } | null> | null;
        } | null;
      } | null;
      readonly identifier?: string | null;
      readonly message?: string | null;
    } | null;
  } | null;
};
export type KudosSummaryQuery = {
  response: KudosSummaryQuery$data;
  variables: KudosSummaryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "internalId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "username"
},
v2 = [
  {
    "kind": "Variable",
    "name": "internalId",
    "variableName": "internalId"
  },
  {
    "kind": "Variable",
    "name": "unifiedProfileUsername",
    "variableName": "username"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentLevelArt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentLevelDescription",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentLevelName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentPoints",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxPoints",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nextLevelName",
      "storageKey": null
    }
  ],
  "type": "UnifiedGamificationLevel",
  "abstractKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "UnifiedGamificationRecognitionsTotal",
      "kind": "LinkedField",
      "name": "totals",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "comment",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UnifiedGamificationRecognitionsSummary",
  "abstractKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnifiedQueryErrorExtension",
      "kind": "LinkedField",
      "name": "extensions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "errorType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "statusCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UnifiedQueryError",
  "abstractKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "KudosSummaryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedQuery",
        "kind": "LinkedField",
        "name": "unified",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "unifiedProfile",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "gamification",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "levels",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "recognitionsSummary",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "UnifiedGamification",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "UnifiedProfile",
                "abstractKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "KudosSummaryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedQuery",
        "kind": "LinkedField",
        "name": "unified",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "unifiedProfile",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "gamification",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "levels",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "recognitionsSummary",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "type": "UnifiedGamification",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "type": "UnifiedProfile",
                "abstractKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "926330b16b2faff448d0131e41869652",
    "id": null,
    "metadata": {},
    "name": "KudosSummaryQuery",
    "operationKind": "query",
    "text": "query KudosSummaryQuery(\n  $username: String\n  $internalId: String\n) {\n  unified {\n    unifiedProfile(unifiedProfileUsername: $username, internalId: $internalId) {\n      __typename\n      ... on UnifiedProfile {\n        gamification {\n          __typename\n          ... on UnifiedGamification {\n            levels {\n              __typename\n              ... on UnifiedGamificationLevel {\n                id\n                currentLevelArt\n                currentLevelDescription\n                currentLevelName\n                currentPoints\n                maxPoints\n                nextLevelName\n              }\n            }\n            recognitionsSummary {\n              __typename\n              ... on UnifiedGamificationRecognitionsSummary {\n                id\n                totals {\n                  comment\n                  count\n                }\n              }\n            }\n            id\n          }\n        }\n        id\n      }\n      ... on UnifiedQueryError {\n        identifier\n        message\n        extensions {\n          errorType\n          statusCode\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3898beb09c2dee388df7b7f38c738bc4";

export default node;
